<template>
  <a-card nopad>
    <div class="booking-title d-flex justify-space-between">
      <span>Checklist</span>
    </div>
    <div>
      <v-row>
        <v-col>
          <v-row align="center" justify="center">
            <v-switch v-model="flight" /><span class="caption">Flight Details</span>
          </v-row>
        </v-col>
        <v-col>
          <v-row align="center" justify="center">
            <v-switch v-model="welcome" /><span class="caption">Welcome Sign sent</span>
          </v-row>
        </v-col>
        <v-col>
          <v-row align="center" justify="center">
            <v-switch v-model="client" /><span class="caption">Client's program sent</span>
          </v-row>
        </v-col>
        <v-col>
          <v-row align="center" justify="center">
            <v-switch v-model="appreciation" /><span class="caption">Appreciation sheets</span>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </a-card>
</template>

<script>
export default {
  computed: {
    technical() {
      return this.$store.getters["BookingStore/data"]["technical"] || {};
    },
    flight: {
      get() {
        return this.technical.flight;
      },
      set(val) {
        this.updateTechnical("flight", val);
      },
    },
    welcome: {
      get() {
        return this.technical.welcome;
      },
      set(val) {
        this.updateTechnical("welcome", val);
      },
    },
    client: {
      get() {
        return this.technical.client;
      },
      set(val) {
        this.updateTechnical("client", val);
      },
    },
    appreciation: {
      get() {
        return this.technical.appreciation;
      },
      set(val) {
        this.updateTechnical("appreciation", val);
      },
    },
  },
  methods: {
    updateTechnical(key, val) {
      if (this.$store.getters["BookingStore/isCancelled"]) return;

      const previousTechnical = { ...this.technical };
      const updatedTechnical = { ...this.technical, [key]: val };
      this.$store.dispatch("BookingStore/update", { deep: true, key: "technical", val: updatedTechnical });

      this.$store.dispatch("BookingStore/updateBooking").catch((err) => {
        this.$store.dispatch("BookingStore/update", { deep: true, key: "technical", val: previousTechnical });
        this.$root.$error(err);
      });
    },
  },
};
</script>
